// Time-only for a message from today; date + time otherwise (resumed
// conversations can span midnight).

const timeFormatter = new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' });
// Numeric date (e.g. "8/9") rather than a month name — stays compact.
const dateTimeFormatter = new Intl.DateTimeFormat(undefined, {
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
});

function isSameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

/** `now` is injectable for tests; defaults to the real current time. */
export function formatMessageTime(timestamp: Date, now: Date = new Date()): string {
  return isSameDay(timestamp, now)
    ? timeFormatter.format(timestamp)
    : dateTimeFormatter.format(timestamp);
}
